<script>
import { loadAssetWhiteLabel } from '@composables/utils/loadAsset.ts'
import pkg from '@pkg'
import { ref, onMounted, computed } from 'vue'

import { mobileVersion } from '@/composables/utils/mobileVersion'
import { useServiceWorkerVersionWatcher } from '@/composables/utils/useServiceWorkerVersionWatcher'

export default {
  name: 'registerLayout',

  setup() {
    const { checkForNewVersion, checkIfUnderMaintenance } = useServiceWorkerVersionWatcher()

    const images = Object.values(
      import.meta.glob('@/assets/img/login/*.jpg', {
        eager: true,
        query: '?url',
        import: 'default'
      })
    )
    const currentImageIndex = ref(0)
    const bgImg = ref('')

    const changeBackgroundImage = () => {
      bgImg.value = images[currentImageIndex.value]
      currentImageIndex.value = (currentImageIndex.value + 1) % images.length
    }

    const isApp = () => typeof window.FlutterApp !== 'undefined'

    const webVersion = computed(() => {
      if (!isApp() || !mobileVersion.value) return `Versão web: ${pkg.version}`
      return `Mobile: ${mobileVersion.value.split('@')[1]} | Web: ${pkg.version}`
    })

    onMounted(() => {
      changeBackgroundImage()
      setInterval(changeBackgroundImage, 10000)
      checkForNewVersion()
      checkIfUnderMaintenance()
      window.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          checkForNewVersion()
          checkIfUnderMaintenance()
        }
      })
    })

    return {
      bgImg,
      loadAssetWhiteLabel,
      webVersion
    }
  }
}
</script>

<template>
  <section class="container-fluid onboarding-grid">
    <div class="row vh-100">
      <div class="d-none d-md-block col-md-3 banner">
        <div :style="{ backgroundImage: `url(${bgImg})` }"></div>
      </div>
      <slot></slot>
      <div class="web-version text-end w-100">
        <small>{{ webVersion }}</small>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
@use 'tb-design_system-web/lib/assets/css' as *;

.web-version {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 12px;
  color: #939393;
}
.banner {
  background-size: cover;
  background-position: center;
}
</style>
